export enum ActivityStatus {
    UNKNOWN,
    SHOPPINGCART,
    DELETED,
    LIVE,
    ABANDONCART,
    GROUPUNBOOKED,
    CANCELLED
}